import React, { memo } from 'react'

import { Button, CubeCheck, Divider, Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'

import { NOOP } from 'Utils/stableDefaults'

const setAsMainIcon = <Icon svgComponent={CubeCheck} color="dark" size={iconSize} />
const deleteIcon = <Icon svgComponent={Trash} color="dark" size={iconSize} />

const formatCreatedAt = (isoString) =>
  new Date(isoString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

function Menu({
  createdAt = '',
  onSetAsMain: handleSetAsMain = NOOP,
  onDelete: handleDelete = NOOP,
  isDisabled = false,
}) {
  return (
    <div className="variation-card__menu">
      <span className="variation-card__menu-created-at cgt-caption">
        Created: {formatCreatedAt(createdAt)}
      </span>
      <Divider />
      <Button
        type="ghost"
        variant="with-icon"
        icon={setAsMainIcon}
        size="small"
        customClass="variation-card__menu-button"
        onClick={handleSetAsMain}
        disabled={isDisabled}
      >
        Set as main
      </Button>
      <Button
        type="ghost"
        variant="with-icon"
        icon={deleteIcon}
        size="small"
        customClass="variation-card__menu-button"
        onClick={handleDelete}
        disabled={isDisabled}
      >
        Delete
      </Button>
    </div>
  )
}

Menu.propTypes = {
  createdAt: string,
  onSetAsMain: func,
  onDelete: func,
  isDisabled: bool,
}

export default memo(Menu)
